export const BUSINESS = {
  name: "GTA Garage Doors & Locksmith",
  shortName: "GTA Garage Doors",
  tagline: "Fast. Reliable. There When You Need Us.",
  phone: "+1 647 724 3373",
  phoneHref: "tel:+16477243373",
  phoneDigits: "+16477243373",
  domain: "gta-garagedoors.com",
  url: "https://gta-garagedoors.com",
  address: "Greater Toronto Area, Ontario, Canada",
  rating: 4.9,
  reviewCount: 327,
  hours: "24/7",
  responseTime: "60 min",
};

export const TRUST_BADGES = [
  { label: "Licensed & Insured", icon: "ShieldCheck" },
  { label: "24/7 Available", icon: "Clock" },
  { label: "60-Min Response", icon: "Lightning" },
  { label: "5-Star Rated", icon: "Star" },
];

export const TESTIMONIALS = [
  {
    name: "Michael T.",
    city: "Vaughan",
    quote:
      "My spring snapped at 7am on a Monday. I was already late for work and couldn't get my car out. GTA Garage Doors had a tech at my house within 45 minutes. Fixed on the spot. These guys are the real deal.",
    rating: 5,
  },
  {
    name: "Sandra K.",
    city: "Scarborough",
    quote:
      "Someone tried to kick in my back door overnight. I called at 6am panicking and they were here by 7:15. New door frame, new lock, everything secured before my kids woke up. I can't say enough good things.",
    rating: 5,
  },
  {
    name: "Jason R.",
    city: "Mississauga",
    quote:
      "Locked my keys inside at 11pm. One call, 35 minutes, done. Tech was professional, no damage to my lock. Saved my night.",
    rating: 5,
  },
];

export const IMAGES = {
  heroTechnician:
    "https://images.unsplash.com/photo-1739203469638-d6f54c24a5da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxnYXJhZ2UlMjBkb29yJTIwcmVwYWlyJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3Nzc1Njg0MTR8MA&ixlib=rb-4.1.0&q=85",
  locksmith:
    "https://images.pexels.com/photos/34286675/pexels-photo-34286675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  torontoSkyline:
    "https://images.pexels.com/photos/32203131/pexels-photo-32203131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  garageDoorHouse:
    "https://images.unsplash.com/photo-1652469281665-0ea785b9f743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NTZ8MHwxfHNlYXJjaHwxfHxnYXJhZ2UlMjBkb29yJTIwaW5zdGFsbGF0aW9uJTIwaG91c2V8ZW58MHx8fHwxNzc3NTY4NDM1fDA&ixlib=rb-4.1.0&q=85",
  teamTruck:
    "https://images.unsplash.com/photo-1573495407624-9c6cb5097ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxwbHVtYmVyJTIwdGVhbSUyMHRydWNrfGVufDB8fHx8MTc3NzU2ODQzNXww&ixlib=rb-4.1.0&q=85",
};
